// import React from 'react'
import useSWR from 'swr'

export default function useBankInfo(id) {
  const {data: bank, error, isValidating} = useSWR(`settings/settlement-banks`)

  return {
    bank: bank?.data,
    isLoading: isValidating,
    isError: error
  }
}